import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BottomNavigation, BottomNavigationAction, styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import { AuthService } from '~/services/service.auth';
import { useService } from '~/services/service.base';
import { Icons } from '../atoms/icons';
const StyledBottomNav = styled(BottomNavigation)({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 64,
    zIndex: 2,
});
export const BottomNav = observer(() => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [value, setValue] = useState(pathname);
    const authSvc = useService(AuthService);
    const nav = useNavigate();
    const handleChange = useCallback((_, v) => nav(v, { state: { isNav: true } }), [nav]);
    const allBottomNavRoutes = useMemo(() => [ROUTES.FUNDS.path, ROUTES.FUNDS.MEDIA.path, ROUTES.FUNDS.BOOKS.path, ROUTES.FUNDS.CONTACTS.path], []);
    useEffect(() => {
        const foundPath = allBottomNavRoutes.reduce((resultPath, path) => {
            if (pathname && pathname.includes(path)) {
                return path;
            }
            return resultPath;
        }, '');
        setValue(foundPath);
    }, [pathname, allBottomNavRoutes]);
    return (_jsxs(StyledBottomNav, { showLabels: true, value: value, onChange: handleChange, children: [_jsx(BottomNavigationAction, { value: ROUTES.FUNDS.path, label: t('BOTTOM_NAV_FOUNDS'), icon: _jsx(Icons.Recent, {}) }), _jsx(BottomNavigationAction, { value: ROUTES.FUNDS.MEDIA.path, label: t('BOTTOM_NAV_MEDIA'), icon: _jsx(Icons.Media, {}) }), _jsx(BottomNavigationAction, { value: ROUTES.FUNDS.BOOKS.path, label: t('BOTTOM_NAV_BOOKS'), icon: _jsx(Icons.Book, {}) }), authSvc.isLogged && (_jsx(BottomNavigationAction, { value: ROUTES.FUNDS.CONTACTS.path, label: t('BOTTOM_NAV_CONTACTS'), icon: _jsx(Icons.Contact, {}) }))] }));
});
